import { render } from "./AddPermissionPage.vue?vue&type=template&id=7ca8fdd2&ts=true"
import script from "./AddPermissionPage.vue?vue&type=script&lang=ts"
export * from "./AddPermissionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__